import { v4 as uuid } from 'uuid';
import { default as config } from '../config';

// 인증 요청 URI
let authRequestUri = config.mykeepin.api.authRequest;

/**
 * Mykeepin 인증서버에게 인증 요청을 하는 함수
 * @param {Object} param0
 * @param {String} param0.serviceId 마이키핀 서비스 아이디
 * @param {String} param0.redirectUri 인증 완료 후 리다이렉트 될 uri
 * @param {Number} param0.type 인증 타입
 * @param {String?} param0.did 사용자 DID
 * @param {String?} param0.data 추가 데이터 
 */
function authRequest({
  serviceId, redirectUri, type, did = '', data = '',
} = {}) {
  // Type check
  if (typeof serviceId !== 'string' || typeof redirectUri !== 'string'
  || typeof type !== 'number' || typeof did !== 'string' || typeof data !== 'string') {
    throw new TypeError();
  }
  // 고유 state token 생성
  const stateToken = uuid();
  // URI encoding
  const encodedRedirectUri = encodeURIComponent(redirectUri);
  authRequestUri = authRequestUri.concat(`?service_id=${serviceId}`);
  authRequestUri = authRequestUri.concat(`&redirect_uri=${encodedRedirectUri}`);
  authRequestUri = authRequestUri.concat(`&state=${stateToken}`);
  authRequestUri = authRequestUri.concat(`&type=${type}`);
  if (did && did !== '') authRequestUri = authRequestUri.concat(`&did=${did}`);
  if (data && data !== '') authRequestUri = authRequestUri.concat(`&data=${data}`);
  return authRequestUri;
}

export default authRequest;
